import { useEffect, useState } from "react";
import { HeartHandshake, Send, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { MatchCard } from "@/components/MatchCard";
import { FullSpinner } from "@/components/States";
import { toast } from "sonner";

export default function MatchAssist() {
  const [data, setData] = useState(null);
  const [note, setNote] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/match-assist").then(({ data }) => { setData(data.request); if (data.request?.note) setNote(data.request.note); });
  useEffect(() => { load(); }, []);
  if (data === null && note === "") { /* still initial */ }

  const submit = async () => {
    setBusy(true);
    try { await api.post("/match-assist", { note }); toast.success("Request sent to our matchmaking team"); load(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  const sendMsg = async () => {
    if (!msg.trim()) return;
    try { await api.post("/match-assist/message", { text: msg }); setMsg(""); toast.success("Message sent"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  const req = data;
  return (
    <div className="max-w-3xl mx-auto space-y-5" data-testid="match-assist-page">
      <div>
        <h1 className="font-serif text-3xl font-bold text-[#58111A] flex items-center gap-2"><HeartHandshake className="w-6 h-6 text-[#C59B27]" /> ManaJodi Match Assist</h1>
        <p className="text-sm text-[#605255]">Get personal help from a Relationship Manager who curates profiles for you. We assist — you always decide.</p>
      </div>

      <div className="mj-card p-5">
        <label className="mj-label">What are you looking for?</label>
        <textarea className="mj-input" rows={4} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Tell us about your ideal partner, priorities and any preferences…" data-testid="assist-note" />
        <button onClick={submit} disabled={busy} className="btn-primary mt-3" data-testid="assist-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : req ? "Update Request" : "Request Match Assistance"}</button>
        {req && <span className="ml-3 text-sm text-[#781826] font-semibold capitalize">Status: {req.status?.replace("_", " ")}</span>}
      </div>

      {req?.suggestion_profiles?.length > 0 && (
        <div>
          <h2 className="font-serif text-xl font-semibold text-[#58111A] mb-3">Curated for you</h2>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">{req.suggestion_profiles.map((p) => <MatchCard key={p.user_id} p={p} />)}</div>
        </div>
      )}

      {req && (
        <div className="mj-card p-5">
          <h2 className="font-serif text-lg font-semibold text-[#261A1C] mb-3">Chat with your Relationship Manager</h2>
          <div className="space-y-2 max-h-64 overflow-y-auto mb-3">
            {(req.messages || []).length === 0 && <p className="text-sm text-[#9E7B1B]">No messages yet.</p>}
            {(req.messages || []).map((m, i) => (
              <div key={i} className={`flex ${m.from === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[75%] px-3 py-2 rounded-2xl text-sm ${m.from === "user" ? "bg-[#781826] text-white" : "bg-[#FAF3E0] text-[#261A1C]"}`}>{m.text}</div>
              </div>
            ))}
          </div>
          <div className="flex gap-2">
            <input className="mj-input" value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Message your Relationship Manager…" onKeyDown={(e) => e.key === "Enter" && sendMsg()} data-testid="assist-msg" />
            <button onClick={sendMsg} className="btn-primary shrink-0"><Send className="w-4 h-4" /></button>
          </div>
        </div>
      )}
    </div>
  );
}
